export const cardTheme = {
  MuiCard: {
    variants: [
      {
        props: { variant: "panelCard" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
          padding: "10px",
          [theme.breakpoints.up("sm")]: {
            padding: "18px",
          },
          borderRadius: 16,
          boxShadow: theme.shadows[2],

          "& .panelCardHeader": {
            height: "38px",
            width: "100%",
            marginBottom: "16px",
          },
        }),
      },
    ],
    styleOverrides: {
      root: {
        padding: "20px",
        borderRadius: "15px",
      },
    },
  },
};
